import { useEffect, useState } from "react";
import axios from "axios";
import { Package, CheckCircle2 } from "lucide-react";
import { API, inr } from "@/lib/api";

export const productImg = (p) => (p.has_image ? `${API}/products/${p.id}/image` : null);

export const ProductCard = ({ p, selected, onSelect, children }) => (
  <div onClick={onSelect} data-testid={`product-card-${p.id}`}
    className={`group relative overflow-hidden rounded-2xl border bg-[#0B0F17] transition-[transform,border-color] duration-200 ${onSelect ? "cursor-pointer hover:-translate-y-0.5" : ""} ${selected ? "border-emerald-500" : "border-[#1F293D] hover:border-emerald-500/40"}`}>
    <div className="aspect-[4/3] bg-white/5">
      {productImg(p) ? <img src={productImg(p)} alt={p.name} className="h-full w-full object-cover" /> : <div className="grid h-full place-items-center"><Package className="h-10 w-10 text-slate-600" /></div>}
    </div>
    {selected && <CheckCircle2 className="absolute right-3 top-3 h-6 w-6 rounded-full bg-[#0B0F17] text-emerald-400" />}
    <div className="p-4">
      <p className="font-display text-lg font-bold text-white">{p.name}</p>
      {p.description && <p className="mt-1 line-clamp-2 text-xs text-slate-400">{p.description}</p>}
      <p className="mt-3 font-mono text-emerald-400">{inr(p.price)}</p>
      {p.daily_return > 0 && p.return_days > 0 && (
        <p className="mt-2 rounded-md border border-amber-500/30 bg-amber-500/10 px-2 py-1 text-xs text-amber-300" data-testid={`product-plan-${p.id}`}>
          {inr(p.daily_return)}/day × {p.return_days} days = {inr(p.daily_return * p.return_days)}
        </p>
      )}
      {children}
    </div>
  </div>
);

export const useProducts = () => {
  const [products, setProducts] = useState(null);
  useEffect(() => { axios.get(`${API}/products`).then((r) => setProducts(r.data)).catch(() => setProducts([])); }, []);
  return products;
};
